export const sentry = {
  dns: 'https://565ed45c032e44c199825c461608eb17@sentry.io/1826723',
  enabled: false,
};